import {ProductListState} from "../ProductListProvider";

export const buildRequestString = (state: ProductListState): string => {
  if (!state.instance) {
    return "";
  }
  const {filter} = state.instance;
  filter.applyFilterValue(state.filters);

  const {customerId, customerGroupId, currencyCode, categoryId, offset, order, orderBy, limit} =
    state.instance.requestParams;

  const requestParams = {customerId, customerGroupId, currencyCode, categoryId, offset, order, orderBy, limit} as {
    [k: string]: string | number;
  };

  const initParams: string = Object.keys(requestParams)
    .filter((requestParamKey) => requestParams[requestParamKey] !== undefined && requestParams[requestParamKey] !== 0)
    .map((key) => {
      if (key === "limit") {
        // in sess
        const limitSum = Number(requestParams[key]) + Number(requestParams.offset);

        return `${key}=${limitSum}`;
      } else if (key === "offset") {
        // remove offset from key
        return "";
      } else if (key === "orderBy" && requestParams[key] === "innofind" && state.instance?.requestParams.userId) {
        return `${key}=${requestParams[key]}&userId=${state.instance.requestParams.userId as string}`;
      } else {
        return `${key}=${requestParams[key]}`;
      }
    })
    .filter((key) => !!key)
    .join("&");

  const filterParams = Array.from(filter.filterItems.values())
    .filter((filterItem) => filterItem.paramValue)
    .map((filterItem) => {
      const fieldParams = filterItem.paramValue.split(",");
      const fieldParamsString = fieldParams.sort().join(",");

      return `${filterItem.field}=${fieldParamsString}`;
    })
    .join("&");

  return filterParams ? filterParams + "&" + initParams : initParams;
};
